import React from 'react';

import { NoContent, Container, Message, IconOk } from './styles';

interface IType {
  type: string;
}

function CleanBase({ type }: IType) {
  return (
    <NoContent>
      <Container>
        <IconOk />
        <Message>{`Nenhum ${type} foi encontrado em nossa base.`}</Message>
      </Container>
    </NoContent>
  );
}

export default CleanBase;
